import { useEffect, useState } from "react";
import DataTable from "../../component/DataTable";
import { Link } from "react-router-dom";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";

const DeleteEndpoint = ApiEndpoints.leadership.Delete;
const ListEndpoint = ApiEndpoints.leadership.List;
const EditPath = "edit-leadership";
const tableHeader = ["Date", "Title", "slug"];
const tbody = ["createdAt", "title", "slug"];

export default function Leadership() {

  const [data, setData] = useState([]);

  const dataFetch = async () => {
    try {
      const response = await ApiRequest("GET", ListEndpoint);
      const result = response.leaderships;
      setData(result);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    dataFetch();
  }, []);

  const handleDelete = async (leadership_id) => {
    const payload = { leadership_id };
    try {
      const response = await ApiRequest("POST", DeleteEndpoint, payload);
      toast.success(response.message)
      dataFetch();
    } catch (error) {
      console.error(error);
    }
  };

  const pagename = {
    name: 'leadership Management',
    user: 'Admin',
    innerpage: 'leadership Management / leaderships'
  }

  return (
    <>
      <AdminHeader pagename={pagename} />

      <div className="add-btn-section">
        <Link className="admin-add-btn" to="/add-leadership">Add +</Link>
        <DataTable
          data={data}
          tableHeader={tableHeader}
          tbody={tbody}
          editPath={EditPath}
          onDelete={handleDelete}
        />
      </div>
    </>
  );
}
